module.exports = "<div class=\"table\">\n\n  <div class=\"cell\">\n\n    <div class=\"row\">\n\n      <div class=\"column small-24 text-center\">\n\n        <a class=\"close\" ui-sref=\"^\">\n          <img src=\"/img/close.svg\">\n        </a>\n\n        <span ng-bind-html=\"vm.profile.html\"></span>\n\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/profile/profile.html
// module id = 115
// module chunks = 0